import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import LabelSelectButton from 'components/common/LabelSelectButton';
import {stateOption} from 'data/option';
import {allowStateStatus} from 'data/status';
import {
  changeAllowStateBackOffice,
  changeAllowStateBackOfficeRequestApproval,
  changeUsersPermissions,
} from 'function/api';
import {IPermissionState} from 'interfaces/interface';
import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {userInfoState} from 'utils/Atoms';
import {minmax} from 'utils/minmax';
import {useFormatMsg} from 'utils/useFormatMsg';

type Props = {
  selectItem: any;
  closeModal: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
};

const ChangeStateModal = ({
  selectItem,
  closeModal,
  setIsLoading,
  setErrorModal,
}: Props) => {
  const userInfo = useRecoilValue(userInfoState);

  const [state, setState] = useState<IPermissionState | ''>('');

  const [completeModal, setCompleteModal] = useState(false);

  const completeDetailText = state
    ? `"${selectItem.name}" 의 상태가 "${useFormatMsg(
        allowStateStatus[state].text,
      )}" 변경되었습니다`
    : '';

  useEffect(() => {
    return () => {
      setState('');
      setCompleteModal(false);
    };
  }, []);

  return (
    <>
      <CommonModal closeModal={closeModal}>
        <BusinessModalContainer>
          <BusinessModalHeader>
            <DefaultText
              text="state"
              textStyle={{
                fontSize: minmax(40),
              }}
            />
            <DefaultImageView
              source="images/common/close.png"
              onClick={closeModal}
              style={{
                width: minmax(30),
                height: minmax(30),
                margin: minmax(15),
                cursor: 'pointer',
              }}
            />
          </BusinessModalHeader>

          <DefaultText
            text="변경할 상태를 선택해주세요."
            textStyle={{
              fontSize: minmax(30),
            }}
          />

          <LabelSelectButton
            value={state}
            setValue={setState}
            options={stateOption}
            buttonsWrapStyle={{justifyContent: 'center'}}
            buttonStyle={{width: '30%'}}
          />

          <DefaultButton
            text="change"
            actived={1}
            buttonStyle={{
              width: '100%',
              backgroundColor: state ? colors.primary2 : colors.lighterGray,
            }}
            textStyle={{fontSize: minmax(25)}}
            onClick={async () => {
              //
              if (state) {
                let data: any = {
                  permissionDto: {
                    type: selectItem.permissionType,
                    userUUID: selectItem.userUUID,
                    permissionUUID: selectItem.permissionUUID,
                    role: selectItem.role,
                    state: state,
                  },
                  permissionProfileDto: {
                    type: selectItem.permissionType,
                    permissionProfileUUID: selectItem.permissionProfileUUID,
                  },
                };

                let result;

                result = await changeUsersPermissions({
                  userInfo,
                  setIsLoading,
                  setErrorModal,
                  data,
                });

                if (result) setCompleteModal(true);
              }
            }}
          />
        </BusinessModalContainer>
      </CommonModal>
      {completeModal && (
        <CommonModal
          title="상태 변경 완료!"
          detail={completeDetailText}
          firstButtonText="confirm"
          firstButtonClick={() => {
            closeModal();
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default ChangeStateModal;

const BusinessModalContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${minmax(20)};
`;

const BusinessModalHeader = styled.div`
  width: 100%;
  margin-bottom: ${minmax(10)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;
